var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ManagementPage", {
    attrs: {
      pageName: _vm.$tc("ImportNoun", 1) + " / " + _vm.$tc("Layer", 2),
      grid: ""
    },
    scopedSlots: _vm._u([
      {
        key: "top-left",
        fn: function() {
          return [
            _c("imports-form", {
              ref: "importsForm",
              attrs: {
                layers: _vm.layers,
                "layer-options": _vm.layerOptions,
                loading: _vm.loading
              },
              on: {
                "submit-form": _vm.createImport,
                "submit-external-form": _vm.createExternalImport
              }
            })
          ]
        },
        proxy: true
      },
      {
        key: "bottom-left",
        fn: function() {
          return [_c("Imports-map")]
        },
        proxy: true
      },
      {
        key: "top-right",
        fn: function() {
          return [
            _c("table-view-submitted-files", {
              ref: "importsTable",
              on: {
                "set-import-obj": _vm.setImportObj,
                validate: _vm.handleValidate,
                "clear-conflicts-table": _vm.clearConflictsTable
              }
            })
          ]
        },
        proxy: true
      },
      {
        key: "bottom-right",
        fn: function() {
          return [
            _c("table-view-conflicts", {
              ref: "conflictsTable",
              attrs: { "import-obj": _vm.importObj, layers: _vm.layers },
              on: {
                "clear-selected-import": function($event) {
                  _vm.importObj = {}
                },
                "refresh-imports-table": _vm.refreshImportsTable
              }
            })
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ad0ce12e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ad0ce12e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ImportsView.vue
// module id = null
// module chunks = 